var $b03b45b62a7ccae4$exports = {};
$b03b45b62a7ccae4$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de culori`,
    "colorSwatch": `specimen de culoare`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `Glisor 2D`
};


export {$b03b45b62a7ccae4$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
